module.exports = __webpack_public_path__ + "fonts/Gilroy-Regular.86bc2a5.otf";